import reducerConstant from 'common/reducerConstants';

export function getNotifications(obj) {
  return {
    type: reducerConstant.getNotifications,
    payload: {
      ...obj,
    },
  };
}

export function getNotificationsSuccess(obj) {
  return {
    type: reducerConstant.getNotificationsSuccess,
    payload: {
      ...obj,
    },
  };
}

export function getNotificationsFailed(obj) {
  return {
    type: reducerConstant.getNotificationsFailed,
    payload: {
      ...obj,
    },
  };
}

export function getUnreadNotificationsCount() {
  return {
    type: reducerConstant.getUnreadNotificationsCount,
  };
}

export function getUnreadNotificationsCountSuccess(obj) {
  return {
    type: reducerConstant.getUnreadNotificationsCountSuccess,
    payload: {
      ...obj,
    },
  };
}

export function markNotificationsAsRead() {
  return {
    type: reducerConstant.notificationsMarkAsRead,
    payload: {},
  };
}

export function markNotificationsAsReadSuccess() {
  return {
    type: reducerConstant.notificationsMarkAsReadSuccess,
    payload: {},
  };
}
